import highlight from 'highlight.js/lib/core';
import javascript from 'highlight.js/lib/languages/javascript';
import python from 'highlight.js/lib/languages/python';
import 'highlight.js/styles/monokai-sublime.css';

highlight.registerLanguage('javascript', javascript);
highlight.registerLanguage('python', python);

window.hljs = highlight;
